
<div>
  <div v-if="selectedUserName">
    <input disabled :value="`${selectedUserName}`"/>
    <button type="button" class="btn-icon grey-to-red" @click="removeUser" id="remove-user">
      <icon class="times"></icon>
    </button>
  </div>
  <a-select v-else-if="isPortalUser"
      :options="portalUserOptions"
      @input="selectUserAccount"
      bind-by-object>
  </a-select>
  <search-input v-else v-model="q" @reset="resetSearch" @keydown.esc.stop="resetSearchOrModal" placeholder="Search" id="search-users"/>

  <!-- Search results show as dropdown list -->
  <matrix
    v-if="hasQ"
    class="search-list"
    has-data>
    <template slot="table-body">
      <t-row class="prompt" v-if="searchProgress">
        <t-column>
          <strong>{{searchProgress}}</strong>
        </t-column>
      </t-row>

      <!-- Search results from query -->
      <row v-for="userAccount in usersFromQuery" v-bind:key="userAccount.id">
        <prefix size="45">
          <avatar :user=userAccount :current-user-id="currentUserId"></avatar>
        </prefix>

        <column class="row-title">
          <div class="details link-tag" style="display: flex; flex-direction: column;">
            <strong class="crayon blue">{{userAccount.first_name}} {{userAccount.last_name}}</strong>
            {{userAccount.email}}
          </div>
        </column>

        <suffix class="sz100">
          <button class="btn blue" @click="selectUserAccount(userAccount)">Select</button>
        </suffix>
      </row>

      <!-- Always display Relative User in search results -->
      <row>
        <column class="row-title">
          <div class="details link-tag">
            <strong class="crayon blue">{{relativeUserText}}</strong>
          </div>
        </column>
        <suffix class="sz100">
          <button class="btn blue" @click="selectUserAccount(relativeUser)">Select</button>
        </suffix>
      </row>
    </template>
  </matrix>
</div>
